import {writable} from '@convincely/components/src/library.js';

export const funnelAntiFlickerTimeout = writable();
export const funnelHasLoaded = writable(false);
